import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'

export default function ServiceEndBanner() {
  return (
    <Container>
      <Title>【サービス終了のお知らせ】</Title>
      <Message>
        「Ambass」は、2025年12月31日をもって、サービスを終了することとなりました。詳しくは、下記のページをご覧ください。
      </Message>
      <StyledLink href='/close'>サービス終了のお知らせ</StyledLink>
    </Container>
  )
}

const Container = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  background: #eb5757;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

const Title = styled.p`
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  margin: 0;
`

const Message = styled.p`
  font-size: 12px;
  color: #ffffff;
  text-align: left;
  margin: 0;
`

const StyledLink = styled(Link)`
  font-size: 12px;
  color: #ffffff;
  text-decoration: underline;
  cursor: pointer;
`
